import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";



function ModalCompletarReserva({reserva, quienEs}){

    // variables modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
     const contraparte = quienEs === "Vendedor" ? "comprador" : "vendedor";
    

    
    async function completarReserva(){
        try{
            const resConfir = await axios.post("/completar-reserva", {
                params: { idReserva: reserva?._id, quienEs}
            });

            if (!resConfir?.data?.exito) {
                await Swal.fire({
                    icon: "error",
                    title: "No fue posible completar",
                    text: resConfir?.data?.mensaje || "Intenta nuevamente.",
                    customClass: {
                        popup: 'mi-modal',
                        confirmButton: 'mi-boton-confirmar',
                        cancelButton: 'mi-boton-cancelar'
                    }
                });
                return;
            }

            await Swal.fire({
                icon: "success",
                title: "Reserva completa",
                text: "La reserva fue completada correctamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
            window.location.reload();
            return
        }
        catch(err){
            await Swal.fire({
                icon: "error",
                title: "Error al completar reserva",
                text: err?.response?.data?.mensaje || "No fue posible completar la reserva. Intenta nuevamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }
    }
 

    return(
        <div>
        <Button className="w-100 mt-3 rounded-pill fw-semibold" variant="primary" onClick={handleShow}>
            <i className="bi bi-calendar-check me-2"></i>
            Completar reserva
        </Button>

        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold text-dark">
                    Completar servicio
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    <div className="text-center mb-4">
                        <div className="mb-3">
                            <i className="bi bi-check2-circle text-success" style={{ fontSize: "2.4rem" }}></i>
                        </div>

                        <h5 className="fw-bold mb-2">¿El servicio ya finalizó?</h5>

                        <p className="text-muted mb-0">
                            Esperamos que todo haya salido muy bien. Para completar el proceso, confirma que el servicio fue prestado correctamente.
                        </p>
                    </div>

                    <div className="alert alert-warning border-0 rounded-4 small mb-3" role="alert">
                        <div className="fw-semibold mb-1">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            Importante
                        </div>
                        Si no confirmas ni reportas un problema, la reserva se completará automáticamente 4 horas después de la hora final del servicio.
                    </div>

                    <button onClick={completarReserva} className="btn btn-primary rounded-pill w-100 fw-semibold py-2">
                        <i className="bi bi-check2-circle me-2"></i>
                        Confirmar servicio completado
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
    );

}



export default ModalCompletarReserva;